
import * as types from './actionTypes';
import sblApi from '../api/sblApi';
import {SBL_LOGIN_RESPONSE} from "./actionTypes";
import ApiUtils from "../api/apiUtils";

export function getSblLogin(session_id) {
    return function (dispatch) {

        console.log('getSblLogin session id: ' + session_id);
        localStorage.setItem('sbl-login-response', null);
        return sblApi.getLoginSboResponse(session_id)
            .then(async response => {
                console.log('response success');
                localStorage.setItem('sbl-login-response', response);
                dispatch({type: types.SBL_LOGIN_RESPONSE, response: response});
                return response;
            })
            .catch((err) => {
                console.log("getSblLogin error: ", err);
                return null;
            });
    }
}

export function getSblLoginMOCK(session_id) {
    return function (dispatch) {

        console.log('getSblLoginMOCK session id: ' + session_id);
        return sblApi.getLoginSboResponseMOCK(session_id)
            .then(async response => {
                localStorage.setItem('sbl-login-response', response);
                //console.log('getSblLoginMOCK success. response: ' + JSON.stringify(response));
                dispatch({type: types.SBL_LOGIN_RESPONSE, response: response});
                return response;
            });
    }
}



// WEBPACK FOOTER //
// ./src/actions/sblLoginActions.js